/**
 * Block: new-double-feature-slider
 * Initialize Slick slider for mobile .features-slider elements.
 * Slick is loaded globally via WordPress (jQuery + slick.js).
 */

export function init() {
  const sliders = document.querySelectorAll('.new-double-feature-slider .features-slider');
  if (!sliders.length) return;
  if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') return;

  const $ = jQuery;

  sliders.forEach((el) => {
    if ($(el).hasClass('slick-initialized')) return;

    $(el).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      centerMode: false,
      variableWidth: true,
    });
  });
}
